import { all, fork } from 'redux-saga/effects';

import { effects as shipmentEffects } from 'state/mrDistribution/shipments';

export default function* mrDistributionSaga() {
  yield all([fork(shipmentEffects)]);
}
